"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocatorService = void 0;
const request_1 = require("../common/request");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
class LocatorService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
    }
    getPoiByCode(poiCode, category, divisionCode, callback) {
        const request = new request_1.Request(`poiLocator/v1/poi/${poiCode}`, {
            queryParams: {
                category,
                divisionCode,
            },
        });
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    getPoiByCodePubbl(poiCode, category, divisionCode, pro) {
        const request = new request_1.Request("poiLocator/v1/poi/" + poiCode, {
            queryParams: {
                category,
                divisionCode,
                pro,
            },
        }, undefined, undefined, "url_pub");
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    postPoiCrDati(category = "AGENZIA", idIniziativa) {
        const headers = {};
        const body = {};
        const queryParams = { category, idIniziativa };
        const request = new request_1.Request("poiLocator/v1/iniziativa/poi", { body, headers, queryParams }, false);
        return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
    }
    postBoundsPoiCrDati(category, idIniziativa, lat, lng) {
        const headers = {};
        const params = {
            idIniziativa: idIniziativa,
            category: category,
            latitudine: lat,
            longitudine: lng,
        };
        const request = new request_1.Request("poiLocator/v1/iniziativa/bounds/poi", { headers, queryParams: params }, false);
        return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
    }
    getPoiByIstatCode(provinceIstatCode, category, divisionCode, itemType, brandCode, callback) {
        const request = new request_1.Request(`poiLocator/v1/provinces/${provinceIstatCode}/poi`, {
            queryParams: {
                category,
                divisionCode,
                itemType,
                brandCode,
                callback,
            },
        });
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    getPoiByCap(zipCode, category, divisionCode, itemType, brandCode, callback) {
        const request = new request_1.Request(`poiLocator/v1/zipCodes/${zipCode}/poi`, {
            queryParams: {
                category,
                divisionCode,
                itemType,
                brandCode,
                callback,
            },
        });
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    getPoiByDistance(lat, lng, neLat, neLng, swLat, swLng, maxItem, category, divisionCode, itemType, brandCode, callback) {
        const request = new request_1.Request("poiLocator/v1/bounds/poi", {
            queryParams: {
                lat,
                lng,
                neLat,
                neLng,
                swLat,
                swLng,
                maxItem,
                category,
                divisionCode,
                itemType,
                brandCode,
                callback,
            },
        });
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    // POST /bounds/poi
    postBoundsPoi(category, lat, lng, agenciesCodes) {
        const body = agenciesCodes;
        const headers = {
            "x-canale": "HIP",
            "x-user-family": "CLIENTE",
            "x-media": "WEB",
        };
        const queryParams = {
            category,
            lat,
            lng,
        };
        const request = new request_1.Request("poiLocator/v1/bounds/poi", {
            body,
            headers,
            queryParams,
        });
        return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
    }
    // POST /bounds/categorizedPoi
    postBoundsCategorizedPoi(category, lat, lng) {
        const body = {
            categories: [category],
            lng: lat,
            lat: lng,
            // "callback": "",
            // "brandCode": "",
            // "itemType": 23998077,
            maxItem: 50000,
            swLng: 6.6,
            swLat: 36.6,
            neLng: 18.5,
            neLat: 47.1,
            // "divisionCode": ""
        };
        const headers = {
            "x-canale": "HIP",
            "x-user-family": "CLIENTE",
            "x-media": "WEB",
        };
        const request = new request_1.Request("poiLocator/v1/bounds/categorizedPoi", { body, headers }, undefined, undefined, "url_pub");
        return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
    }
    // GET /poi
    getPoi(category, pro) {
        const body = {};
        const headers = {};
        const queryParams = {
            category,
            pro,
        };
        const request = new request_1.Request("poiLocator/v1/poi", { body, headers, queryParams }, undefined, undefined, "url_pub");
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    // POST /bounds/poi
    postBoundsPoiPubbl(category, lat, lng, pro, agenciesCodes) {
        const body = agenciesCodes;
        const headers = {
            "x-canale": "HIP",
            "x-user-family": "CLIENTE",
            "x-media": "WEB",
        };
        const queryParams = {
            category,
            lat,
            lng,
            maxItem: 50000,
            pro,
        };
        const request = new request_1.Request("poiLocator/v1/bounds/poi", { body, headers, queryParams }, undefined, undefined, "url_pub", true);
        return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
    }
    // GET /sia
    getSiaByCodeList(codeList) {
        const body = {};
        const headers = {};
        const queryParams = {};
        const request = new request_1.Request("tpdsia/v1/agenzie/" + codeList + "/sia", { body: body, headers: headers, queryParams: queryParams }, undefined, undefined, "url_pub");
        // request.completeUrl = 'http://localhost:9080/tpdsia/agenzie/' + codeList + '/sia';
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    // GET /agenzie
    getAgencies(idSessione) {
        const body = {};
        const headers = {};
        const queryParams = {};
        const request = new request_1.Request("quotatori/auto/v3/transazioni/" + idSessione + "/agenzie", { body, headers, queryParams }, undefined, undefined, "url_pub");
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
    // POST /showPrice
    postShowPrice(idSessione) {
        const body = {};
        const headers = {};
        const queryParams = {};
        const request = new request_1.Request("quotatori/auto/v2/transazioni/" + idSessione + "/showPrice", { body, headers, queryParams }, undefined, undefined, "url_pub");
        return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
    }
}
exports.LocatorService = LocatorService;
